import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { MrfiktivCreateInsuranceDtoGen } from "@/services/mrfiktiv/v1/data-contracts";

@IsFilterable
export class ReportInsuranceBase implements MrfiktivCreateInsuranceDtoGen {
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.report.insurances.name"
  })
  name: string;

  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.report.insurances.number"
  })
  number?: string;

  type?: MrfiktivCreateInsuranceDtoGen["type"];

  constructor(obj?: Partial<ReportInsuranceBase | MrfiktivCreateInsuranceDtoGen>) {
    this.name = obj?.name ?? "";
    this.number = obj?.number;
    this.type = obj?.type;
  }
}

type IReportInsurance = ReportInsuranceBase;
const ReportInsurance = Filter.createForClass(ReportInsuranceBase);

export { ReportInsurance, IReportInsurance };
